// ----------------------------------------------------------------------
// V2 Modern IconButton Styling

import { alpha } from '@mui/material/styles';
import { PRIMARY_MAIN } from '../palette';

export default function IconButton(theme) {
  const primaryMain = PRIMARY_MAIN;

  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          minHeight: '44px',
          minWidth: '44px',
          borderRadius: theme.shape.borderRadius,
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: alpha(primaryMain, 0.08)
          }
        },
        colorPrimary: {
          backgroundColor: alpha(primaryMain, 0.08),
          color: primaryMain,
          '&:hover': {
            backgroundColor: alpha(primaryMain, 0.15)
          }
        },
        colorSecondary: {
          backgroundColor: alpha(theme.palette.secondary.main, 0.08),
          color: theme.palette.secondary.main,
          '&:hover': {
            backgroundColor: alpha(theme.palette.secondary.main, 0.15)
          }
        }
      }
    }
  };
}
